<template lang="pug">
v-card.card
  v-tooltip(right v-if='selected')
    v-btn(icon large color='primary' left absolute :ripple='false' slot='activator' style='z-index: 0')
      v-icon fas fa-check
    span 目前的方案

  .payment-bar(:class='{ fancy }')

  v-card-title.justify-center(primary-title)
    h6
      slot(name='title')

  v-card-text
    slot(name='body')
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    fancy: { type: Boolean },
    selected: { type: Boolean },
  },
})
</script>

<style scoped lang="sass">
h6
  font-weight: 400
  font-size: 30px

.card
  margin-bottom: 1rem
</style>
